import {
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  spaceMaintainerItemSchema,
  type SpaceMaintainerProduct,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ToothStep } from "./constants";

export type SpaceMaintainerStepKey =
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences
  | typeof StepKeysEnum.tooth;

export const SpaceMaintainerWorkflowConfiguration: ProductWorkflowConfiguration<
  SpaceMaintainerProduct,
  SpaceMaintainerStepKey
> = {
  productType: ProductTypeEnum.spaceMaintainer,
  itemType: ItemTypeEnum.spaceMaintainer,
  steps: [new ToothStep()],
  teethSelection: TeethSelectionEnum.UNIQUE,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: spaceMaintainerItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    const completed: SpaceMaintainerStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.tooth);
    }

    return completed;
  },
};
